import React from "react";
import UserNavbar from "../../components/common/UserNavbar";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";

const UserLayout = (props) => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "7077560638"; 
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:managingdirector@diagnonextlabs.com";
  };

  return (
    <React.Fragment>
      <UserNavbar />
      <main>{props.children}</main>
      <UserFooter />

      {/* ✅ Floating Buttons (fixed for all user pages) */}
      <div className="fixed right-4 bottom-4 flex flex-col items-center gap-3 z-[999]">
        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsAppClick}
          className="p-3 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 transform hover:scale-110"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp size={26} color="#fff" />
        </button>

        {/* Email Button */}
        <button
          onClick={handleEmailClick}
          className="p-3 bg-cyan-500 rounded-full shadow-lg hover:bg-cyan-600 transition-all duration-300 transform hover:scale-110"
          aria-label="Send Email"
        >
          <FaEnvelope size={22} color="#fff" />
        </button>
      </div>
    </React.Fragment>
  );
};

export default UserLayout;
